import { useStaticQuery, graphql } from 'gatsby';

export const useHomepagePromo3Data = () => {
  const { taxonomyTermPromotion } = useStaticQuery(
    graphql`
      query HomepagePromo3Data {
        taxonomyTermPromotion(drupal_internal__tid: { eq: 176 }) {
          relationships {
            field_promoted_content {
              ... on node__event {
                id
                title
                body {
                  summary
                }
                srcSet: field_image {
                  ...eventSrcSet16x9Fragment
                  ...eventSrcSet10x7Fragment
                }
                field_image {
                  imageDerivatives {
                    links {
                      w344_16_9 {
                        href
                      }
                    }
                  }
                  alt
                }
                relationships {
                  type: node_type {
                    name
                  }
                  field_tags {
                    relationships {
                      parent {
                        name
                      }
                    }
                    name
                  }
                }
                path {
                  alias
                }
              }
              ... on node__news {
                id
                title
                body {
                  summary
                }
                srcSet: field_image {
                  ...newsSrcSet16x9Fragment
                  ...newsSrcSet10x7Fragment
                }
                field_image {
                  imageDerivatives {
                    links {
                      w344_16_9 {
                        href
                      }
                    }
                  }
                  alt
                }
                relationships {
                  type: node_type {
                    name
                  }
                  field_tags {
                    relationships {
                      parent {
                        name
                      }
                    }
                    name
                  }
                }
                path {
                  alias
                }
              }
              ... on node__page {
                id
                title
                body {
                  summary
                }
                srcSet: field_image {
                  ...pageSrcSet16x9Fragment
                  ...pageSrcSet10x7Fragment
                }
                field_image {
                  imageDerivatives {
                    links {
                      w344_16_9 {
                        href
                      }
                    }
                  }
                  alt
                }
                relationships {
                  type: node_type {
                    name
                  }
                  field_tags {
                    relationships {
                      parent {
                        name
                      }
                    }
                    name
                  }
                }
                path {
                  alias
                }
              }
              ... on node__place {
                id
                title
                body {
                  summary
                }
                srcSet: field_image {
                  ...placeSrcSet16x9Fragment
                  ...placeSrcSet10x7Fragment
                }
                field_image {
                  imageDerivatives {
                    links {
                      w344_16_9 {
                        href
                      }
                    }
                  }
                  alt
                }
                relationships {
                  type: node_type {
                    name
                  }
                  field_tags {
                    relationships {
                      parent {
                        name
                      }
                    }
                    name
                  }
                }
                path {
                  alias
                }
              }
            }
          }
        }
      }
    `
  );

  // Clean up the field mapping so it's easier to reference them
  // in the component.
  let promo3query =
    taxonomyTermPromotion.relationships.field_promoted_content[0];
  const ratio16x9links = promo3query?.srcSet?.ratio16x9?.links ?? {};
  const ratio16x9 = ratio16x9links
    ? Object.keys(ratio16x9links).map((value) => ratio16x9links[value].href)
    : [];
  const homepagePromo3Data = {
    srcSet: {
      alt: promo3query?.field_image?.alt,
      srcs: {
        ratio16x9
      }
    },
    title: promo3query?.title,
    id: promo3query?.id,
    summary: promo3query?.body?.summary,
    url: promo3query?.path?.alias,
    parentTag:
      promo3query?.relationships?.field_tags[0]?.relationships?.parent[0]?.name,
    tag: promo3query?.relationships?.field_tags[0]?.name,
    image: {
      alt: promo3query?.field_image?.alt,
      // eslint-disable-next-line camelcase
      src: promo3query?.field_image?.imageDerivatives?.links?.w344_16_9?.href
    },
    largeImage: {
      alt: promo3query?.field_image?.alt,
      // eslint-disable-next-line camelcase
      src: promo3query?.field_image?.imageDerivatives?.links?.w344_16_9?.href
    },
    type: promo3query?.relationships?.type?.name
  };

  return homepagePromo3Data;
};
